import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, isRef as _isRef, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("th", null, [
    /*#__PURE__*/ _createElementVNode("td", null, "Room"),
    /*#__PURE__*/ _createElementVNode("td", null, "Priority")
], -1);
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("h5", null, "Pause", -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("td", null, "Would you like to include a pause?", -1);
const _hoisted_5 = { key: 0 };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("th", null, [
    /*#__PURE__*/ _createElementVNode("td", null, "Pause"),
    /*#__PURE__*/ _createElementVNode("td", null, "Priority")
], -1);
const _hoisted_7 = { key: 0 };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("hr", null, null, -1);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("h6", null, "Rules:", -1);
const _hoisted_10 = /*#__PURE__*/ _createTextVNode("  Minimize Number of rooms ");
const _hoisted_11 = /*#__PURE__*/ _createTextVNode("  Do not schedule combined rooms for 1 team ");
const _hoisted_12 = /*#__PURE__*/ _createTextVNode("  Balance Room Occupance ");
import { computed, ref } from "vue";
import { ModalBox, Button, CheckBox } from '@/components/UI';
import { SchedulePrioritySelector } from '@/components/Schedule';
import useRooms from "@/compositions/useRooms";
import { SchedulePriority } from "@/types/rooms";
import { cloneDeep } from "lodash";
import useScheduleTemplates from "@/compositions/useScheduleTemplates";
export default /*#__PURE__*/ _defineComponent({
    props: {
        modelValue: null,
        editGroupId: null,
        startTime: null,
        fixSchedule: { type: Boolean }
    },
    emits: ["close", "submit", "update:modelValue"],
    setup(__props, { emit: emits }) {
        const props = __props;
        const { scheduleTemplates } = useScheduleTemplates();
        const currentGroups = ref(cloneDeep(props.modelValue));
        currentGroups.value[props.editGroupId].start_time = props.startTime.getTime() / 1000;
        const editGroup = computed(() => {
            if (!Object.keys(currentGroups.value).includes(props.editGroupId)) {
                console.error('editGroupId', props.editGroupId, 'does not exists in', currentGroups.value);
            }
            return currentGroups.value[props.editGroupId];
        });
        const scheduleSettings = ref({
            minimize_chosen_rooms: true,
            handle_combined_rooms: editGroup.value.num_slots <= 5,
            balance_room_usage: false,
        });
        const setScheduleTemplate = (id) => {
            const template = scheduleTemplates.value[id];
            Object.entries(template.room_preferences).forEach(([roomId, priority]) => {
                editGroup.value.room_preferences[roomId] = priority;
            });
        };
        const { rooms } = useRooms();
        const numSlots = computed(() => editGroup.value.num_slots);
        const pauseToggle = computed({
            get: () => {
                return editGroup.value.pause_preferences ? editGroup.value.pause_preferences.length > 0 : false;
            }, set: (value) => {
                if (value) {
                    editGroup.value.pause_preferences = new Array(numSlots.value + 1).fill(SchedulePriority.Minor);
                    const center_slot = Math.floor(editGroup.value.pause_preferences.length / 2);
                    editGroup.value.pause_preferences[center_slot] = SchedulePriority.Normal;
                }
                else {
                    editGroup.value.pause_preferences = [];
                }
            }
        });
        const onClose = () => emits('close');
        const onSubmit = async () => {
            Object.values(editGroup.value.teams).forEach(team => team.schedule = []);
            editGroup.value.scheduler_settings = scheduleSettings.value;
            emits('submit', {
                newGroups: currentGroups.value,
                settings: scheduleSettings.value
            });
            emits('update:modelValue', currentGroups.value);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(ModalBox), {
                onClose: onClose,
                title: "Room Preferences",
                submitButtonTitle: "Schedule",
                onSubmit: onSubmit,
                size: 'lg'
            }, {
                default: _withCtx(() => [
                    _createElementVNode("table", null, [
                        _hoisted_1,
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_unref(scheduleTemplates)), ([id, template]) => {
                                    return (_openBlock(), _createBlock(_unref(Button), {
                                        variant: "secondary",
                                        class: "me-2",
                                        onClick: ($event) => (setScheduleTemplate(id)),
                                        key: id
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(template.name), 1)
                                        ]),
                                        _: 2
                                    }, 1032, ["onClick"]));
                                }), 128))
                            ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rooms), (room, roomId) => {
                            return (_openBlock(), _createElementBlock("tr", {
                                key: room.id
                            }, [
                                _createElementVNode("td", null, _toDisplayString(room.name), 1),
                                _createElementVNode("td", null, [
                                    _createVNode(_unref(SchedulePrioritySelector), {
                                        modelValue: _unref(editGroup).room_preferences[roomId],
                                        "onUpdate:modelValue": ($event) => ((_unref(editGroup).room_preferences[roomId]) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ])
                            ]));
                        }), 128))
                    ]),
                    _createElementVNode("div", null, [
                        _hoisted_2,
                        _hoisted_3,
                        _createElementVNode("table", null, [
                            _createElementVNode("tr", null, [
                                _createVNode(_unref(CheckBox), {
                                    modelValue: _unref(pauseToggle),
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(pauseToggle) ? (pauseToggle).value = $event : null))
                                }, null, 8, ["modelValue"]),
                                _hoisted_4
                            ])
                        ])
                    ]),
                    (_unref(pauseToggle))
                        ? (_openBlock(), _createElementBlock("table", _hoisted_5, [
                            _hoisted_6,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(editGroup).pause_preferences, (_pause, index) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    key: 'pauses_' + index
                                }, [
                                    _createElementVNode("td", null, "Pause slot " + _toDisplayString(index + 1), 1),
                                    (_unref(editGroup).pause_preferences)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
                                            _createVNode(_unref(SchedulePrioritySelector), {
                                                modelValue: _unref(editGroup).pause_preferences[index],
                                                "onUpdate:modelValue": ($event) => ((_unref(editGroup).pause_preferences[index]) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                        ]))
                                        : _createCommentVNode("", true)
                                ]));
                            }), 128))
                        ]))
                        : _createCommentVNode("", true),
                    _hoisted_8,
                    _hoisted_9,
                    _createElementVNode("ul", null, [
                        _createElementVNode("li", null, [
                            _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((scheduleSettings.value.minimize_chosen_rooms) = $event))
                            }, null, 512), [
                                [_vModelCheckbox, scheduleSettings.value.minimize_chosen_rooms]
                            ]),
                            _hoisted_10
                        ]),
                        _createElementVNode("li", null, [
                            _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((scheduleSettings.value.handle_combined_rooms) = $event))
                            }, null, 512), [
                                [_vModelCheckbox, scheduleSettings.value.handle_combined_rooms]
                            ]),
                            _hoisted_11
                        ]),
                        _createElementVNode("li", null, [
                            _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((scheduleSettings.value.balance_room_usage) = $event))
                            }, null, 512), [
                                [_vModelCheckbox, scheduleSettings.value.balance_room_usage]
                            ]),
                            _hoisted_12
                        ])
                    ])
                ]),
                _: 1
            }));
        };
    }
});
